import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";

const debitNoteReasons = [
  {
    value: "Underbilling or price difference",
    label: "Underbilling or price difference",
  },
  {
    value: "Short supply of goods/services",
    label: "Short supply of goods/services",
  },
  {
    value: "Additional charges not included earlier",
    label: "Additional charges not included earlier",
  },
  {
    value: "Tax adjustments or corrections",
    label: "Tax adjustments or corrections",
  },
  {
    value: "Change in contract terms or agreements",
    label: "Change in contract terms or agreements",
  },
  {
    value: "Interest or penalty charges",
    label: "Interest or penalty charges",
  },
  {
    value: "Other",
    label: "Other",
  },
];
const creditNoteMaterialReason = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

function DebitNoteAdd() {
  const [visible, setvisible] = useState(true);
  const [loading, setLoading] = useState(true); // State for loading indicator
  // Serch Fuctionallity ....
  const [selectedOption, setSelectedOption] = useState("column");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null); // Track selected row
  const [selectedReason, setSelectedReason] = useState(null);
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [CompanyPurchaseOrder, setCompanyPurchaseOrder] = useState([]);
  const [materialReason, setMaterialReason] = useState(null);

  let navigate = useNavigate();
  const [erplist, setErplist] = useState([]);

  const [file, setFile] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [creditDate, setDabitDate] = useState("");

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    getsearchCompanySpecificCriteria();
    getsetsearchcompanyspecificdaterange();
  }, []);

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  useEffect(() => {
    if (searchCompanySpecificDateRangeId !== 7) {
      getCompanyPurchaseOrder();
    }
  }, [
    searchCompanySpecificCriteriaId,
    searchCompanySpecificDateRangeId,
    searchParameter,
  ]);

  useEffect(() => {
    if (
      formDate !== "" &&
      toDate !== "" &&
      searchParameter2 !== "" &&
      searchCompanySpecificDateRangeId === 7
    ) {
      obj.search_parameter = searchParameter2;
      getCompanyPurchaseOrder();
    }
  }, [searchParameter2]);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 60 && item.add
  );

  //for tax invoice list
  let obj = {
    search_company_specific_criteria_id: searchCompanySpecificCriteriaId,
    search_company_specific_date_range_id: searchCompanySpecificDateRangeId,
    search_parameter: searchParameter,
    offset: 0,
    limit: 100,
  };

  const getCompanyPurchaseOrder = () => {
    axios
      .post(
        "/api/purple-fusion/CompanyPurchesOrder/get/forSerachingandpaggination",
        obj,
        {
          ...headers,
        }
      )
      .then((response) => {
        // const filteredData = response.data.filter(
        //   (item) => item.status === "open"
        // );
        setCompanyPurchaseOrder(response.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for column...

  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 4 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  //for date

  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChange = (selectedOption) => {
    setSelectedReason(selectedOption);
    console.log("Selected Reason:", selectedOption);
  };

  const handleMaterialReasonChange = (selectedOption) => {
    setMaterialReason(selectedOption);
    console.log("Selected Reason:", selectedOption);
  };
  const createTaxInvoice = (data, selectedReason, materialReason) => {
    const { id } = data;
    console.log("Selected Row Data:", data);
    console.log("Selected Reason:", selectedReason);
    console.log("Material Reason:", materialReason);

    if (
      !selectedReason ||
      materialReason === null ||
      id === "" ||
      materialReason === "" ||
      materialReason === undefined
    ) {
      return toast.error("Please select the required field", {
        autoClose: 2000,
        onClose: () => {},
      });
    }
    const formData = new FormData();

    if (file) {
      formData.append("file_content", file);
    }
    formData.append("company_purchase_order_id", id);
    if (inputValue) {
      formData.append("credit_note_number", inputValue);
    }
    if (creditDate) {
      formData.append("credit_note_date", creditDate);
    }
    formData.append("reason_for_debit_note", selectedReason);
    formData.append("inventory_movement", materialReason);

    const formDataObj = Object.fromEntries(formData.entries());
    console.log("Form Data Submitted:", formDataObj);

    axios
      .post("/api/purple-fusion/debitnote/create", formData, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate(`/DebitNoteAll`);
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };

  const customStyles = {
    content: {
      width: "95%",
      height: "95%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  const onRowClicked = (event) => {
    // console.log(event);
    setSelectedRow(event.data); // Set selected row data
  };

  const defaultColDefs = [
    { headerName: "SNO.", field: "sr", width: 65 },
    { headerName: "Supplier Name", field: "suppliername", width: 150 },
    { headerName: "PO Code", field: "code", width: 180 },
    {
      headerName: "Action",
      field: "id",
      width: 120,
      filter: false,
      sortable: false,
      cellRenderer: (params) => (
        <div className="mt-2">
          <button
            onClick={() => {
              createTaxInvoice(
                params?.data,
                selectedReason?.value,
                materialReason?.value
              );
            }}
            className="text-blue-700 w-14 border bg-transparent hover:bg-blue-700 hover:text-white-A700 border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1 text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
          >
            Save
          </button>
        </div>
      ),
    },
  ];

  const gridOptions = {
    overlayNoRowsTemplate: `
            <div id="progress-bar-id" class="flex items-center justify-center">
                <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
            </div>
        `,
  };
  const ColDefaultVale = { filter: true };

  return (
    <>
      {showActionColumn ? (
        <div>
          <div>
            <Modal isOpen={visible} style={customStyles}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[12px] justify-start md:px-5 w-full">
                    <div className=" flex flex-row justify-between w-[100%]">
                      <Text
                        className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] mr-8"
                        size="txtInterMedium24"
                      >
                        Add Debit Note
                      </Text>
                      <div>
                        <SearchFilter
                          title="Add Credit Note"
                          selectedOption={selectedOption}
                          onOptionChange={handleOptionChange}
                          searchCompanySpecificCriteria={
                            searchCompanySpecificCriteria
                          }
                          searchcompanyspecificdaterange={
                            searchcompanyspecificdaterange
                          }
                          searchCompanySpecificCriteriaId={
                            searchCompanySpecificCriteriaId
                          }
                          setsearchCompanySpecificCriteriaId={
                            setsearchCompanySpecificCriteriaId
                          }
                          searchCompanySpecificDateRangeId={
                            searchCompanySpecificDateRangeId
                          }
                          setsearchCompanySpecificDateRangeId={
                            setsearchCompanySpecificDateRangeId
                          }
                          searchParameter={searchParameter}
                          setsearchParameter={setsearchParameter}
                          formDate={formDate}
                          setFormDate={setFormDate}
                          toDate={toDate}
                          setToDate={setToDate}
                          setsearchParameter2={setsearchParameter2}
                        />
                      </div>
                      <div className="flex flex-row items-center justify-end">
                        <Button
                          className="cursor-pointer sticky font-small mb-2 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                          shape="round"
                          color="white"
                          size="base"
                          variant="fill"
                          onClick={() => {
                            setvisible(false);
                            navigate(`/DebitNoteAll`);
                          }}
                        >
                          ╳
                        </Button>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start md:ml-[0] m-1 w-full md:w-full  ">
                      <ToastContainer />
                      <div className="flex flex-col items-start justify-start w-[45%]">
                        <div className="md:gap-5 gap-x-[75px] gap-y-4 grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-[100%] ">
                          <div
                            className="ag-theme-quartz relative"
                            style={{
                              height: "340px",
                              fontSize: "12px",
                            }}
                          >
                            <AgGridReact
                              rowData={CompanyPurchaseOrder.map(
                                (CompanyPurchaseOrder, index) => ({
                                  ...CompanyPurchaseOrder,
                                  sr: index + 1,
                                })
                              )}
                              onRowSelected="single"
                              onRowClicked={onRowClicked}
                              // onCellMouseOver={onRowClicked}
                              onCellKeyDown={onRowClicked} // For detecting the Tab key press
                              columnDefs={defaultColDefs}
                              defaultColDef={ColDefaultVale}
                              suppressMenuHide={true}
                              suppressExcelExport={true}
                              // gridOptions={gridOptions}
                              overlayLoadingTemplate={
                                loading ? "Loading..." : null
                              }
                              overlayNoRowsTemplate={
                                loading
                                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                                  : "No Record Found"
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* Details Panel */}
                      <div className="w-1/2">
                        {selectedRow ? (
                          <RowDetails row={selectedRow} />
                        ) : (
                          <div className="flex items-center justify-center h-full p-4 bg-gray-100 border-l border-gray-200">
                            <p className="text-gray-500">
                              Select a row to see details
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-6 w-full text-xs mt-2">
                      <div className="flex flex-col">
                        <label className="mb-1 font-medium">
                          Select Debit Note Reason
                          <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={debitNoteReasons}
                          value={selectedReason}
                          onChange={handleChange}
                          placeholder="Choose a reason..."
                          isClearable
                          className="w-full"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="mb-1 font-medium">
                          Credit Note Number
                        </label>
                        <input
                          className="border border-gray-300 rounded-md px-3 py-2 text-xs focus:ring-2 focus:ring-blue-500 outline-none"
                          type="text"
                          name="credit_note_number"
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="mb-1 font-medium">
                          Credit Note Date
                        </label>
                        <input
                          className="border border-gray-300 rounded-md px-3 py-2 text-xs focus:ring-2 focus:ring-blue-500 outline-none"
                          type="date"
                          name="credit_note_date"
                          value={creditDate}
                          onChange={(e) => setDabitDate(e.target.value)}
                        />
                      </div>

                      <div className="flex flex-col">
                        <label className="mb-1 font-medium">
                          Upload Credit Note
                        </label>
                        <input
                          type="file"
                          name="file_content"
                          className="border border-gray-300 rounded-md px-2 py-1 cursor-pointer focus:ring-2 focus:ring-blue-500 outline-none"
                          onChange={(e) => setFile(e.target.files[0])}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="mb-1 font-medium">
                          Is There any Material Return?
                          <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={creditNoteMaterialReason}
                          value={materialReason}
                          onChange={handleMaterialReasonChange}
                          placeholder="Choose a reason..."
                          isClearable
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default DebitNoteAdd;

const RowDetails = ({ row }) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    // console.log(row);

    const fetchDetails = async () => {
      try {
        const response = await axios.post(
          `/api/purple-fusion/companypurchaseorderitems/get`,
          { company_purchase_order_id: row.id },
          headers
        ); // Replace with your API endpoint
        setDetails(response.data);
        console.log(response.data);
      } catch (err) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [row.id]); // Dependency array to refetch when row.id changes

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="p-2 w-full h-full bg-gray-50 border-l border-gray-200">
      <h3 className="font-semibold text-sm mb-2">
        Supplier-Purchase order Items
      </h3>
      <div className=" m-auto text-xs grid grid-cols-2 gap-3">
        <p>
          <strong>Supplier Name:</strong> {row.suppliername}
        </p>

        <p>
          <strong>PO Code:</strong> {row.code}
        </p>
      </div>
      {/* Display details in a table format */}
      {details.length > 0 && (
        <div className="overflow-hidden rounded-md m-1">
          <table className="min-w-full mt-2 text-xs border-collapse table-fixed">
            <thead>
              <tr>
                <th className="border text-xs px-4 py-2">Item Name</th>
                <th className="border text-xs px-4 py-2">Code</th>
                <th className="border text-xs px-4 py-2">Quantity</th>
                <th className="border text-xs px-4 py-2">Cost Price</th>
              </tr>
            </thead>
          </table>
          {/* Set a fixed height on tbody and make it scrollable */}
          <div className="max-h-56 overflow-y-auto overflow-x-hidden">
            <table className="min-w-full text-xs border-collapse table-fixed">
              <tbody>
                {details.map((item) => (
                  <tr key={item.id}>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.item_name}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.code_op}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.quantity}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.cost_price}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const SearchFilter = ({
  title = "Search Filter",
  selectedOption,
  onOptionChange,
  searchCompanySpecificCriteria = [],
  searchcompanyspecificdaterange = [],
  searchCompanySpecificCriteriaId,
  setsearchCompanySpecificCriteriaId,
  searchCompanySpecificDateRangeId,
  setsearchCompanySpecificDateRangeId,
  searchParameter,
  setsearchParameter,
  formDate,
  setFormDate,
  toDate,
  setToDate,
  setsearchParameter2,
}) => {
  return (
    <div className="flex flex-row sm:gap-15 items-center justify-start w-full">
      {/* <span className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] mr-8">
        {title}
      </span> */}

      {/* Column Radio Button */}
      <input
        type="radio"
        id="column"
        name="option"
        checked={selectedOption === "column"}
        onChange={(event) => {
          onOptionChange(event);
          setsearchCompanySpecificDateRangeId("");
          setsearchParameter("");
        }}
        className="mr-1 scale-100"
      />
      <label className="text-gray-600 mr-2 text-sm">Column</label>

      {/* Date Radio Button */}
      <input
        type="radio"
        id="date"
        name="option"
        checked={selectedOption === "date"}
        onChange={(event) => {
          onOptionChange(event);
          setsearchCompanySpecificCriteriaId("");
          setsearchParameter("");
        }}
        className="scale-100 mr-1"
      />
      <label className="text-gray-600 text-sm mr-2">Date</label>

      {/* Column Selection */}
      {selectedOption === "column" && (
        <Select
          options={searchCompanySpecificCriteria.map((item) => ({
            label: item.criteria,
            value: item.id,
          }))}
          className="bg-white-A700 border border-gray-200_02"
          onChange={(selectedoption) => {
            setsearchCompanySpecificCriteriaId(selectedoption.value);
          }}
          styles={{
            control: (base) => ({
              ...base,
              height: "30px",
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }),
          }}
        />
      )}

      {/* Date Selection */}
      {selectedOption === "date" && (
        <Select
          options={searchcompanyspecificdaterange.map((item) => ({
            label: item.date_range,
            value: item.search_date_range_id,
          }))}
          className="bg-white-A700 border border-gray-200_02"
          onChange={(selectedoption) => {
            setsearchCompanySpecificDateRangeId(selectedoption.value);
          }}
          styles={{
            control: (base) => ({
              ...base,
              height: "30px",
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }),
          }}
        />
      )}

      {/* Search Input for Column */}
      {selectedOption === "column" && (
        <input
          type="text"
          placeholder="Search..."
          value={searchParameter}
          onChange={(e) => setsearchParameter(e.target.value)}
          className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[30%] ml-3"
        />
      )}

      {/* Date Range Inputs */}
      {selectedOption === "date" && searchCompanySpecificDateRangeId === 7 && (
        <div className="flex flex-row">
          <input
            type="date"
            value={formDate}
            onChange={(e) => {
              setFormDate(e.target.value);
              setsearchParameter2(e.target.value.concat("@" + toDate));
            }}
            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%] ml-3 mr-1 pt-4"
          />
          <span className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2">
            To
          </span>
          <input
            type="date"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              setsearchParameter2(formDate.concat("@" + e.target.value));
            }}
            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] ml-1 pt-4"
          />
        </div>
      )}
    </div>
  );
};
